import { FC, ReactElement } from "react";

import { Box, Tooltip } from "@mui/material";
import __ from "src/utils/Translations";

export const SUBMIT_LIMITATION_TOOLTIP_KEY =
  "Termin niedostępny ze względu na ograniczenie czasowe w składaniu wniosków";

interface ISubmitLimitationTooltipProps {
  children: ReactElement;
}

/**
 * Wraps a disabled day element with a tooltip explaining the submit limitation.
 * The Box wrapper is required so the tooltip renders correctly on a disabled element.
 */
const SubmitLimitationTooltip: FC<ISubmitLimitationTooltipProps> = ({
  children,
}) => (
  <Tooltip title={__(SUBMIT_LIMITATION_TOOLTIP_KEY)} placement="top" arrow>
    <Box component="span" sx={{ display: "inline-block", lineHeight: 0 }}>
      {children}
    </Box>
  </Tooltip>
);

export default SubmitLimitationTooltip;
